import PageHero from '../components/PageHero.jsx';
import MedicalInfoCard from '../components/MedicalInfoCard.jsx';
import { FadeUp } from '../components/Motion.jsx';
import { IconPin, IconGlobe } from '../components/Icons.jsx';

const EMA_URL = 'https://www.ema.europa.eu/en/medicines/human/EPAR/foscan#product-information';

const offices = [
  {
    name: 'biolitec Pharma Ltd. — Jena',
    lines: ['Otto-Schott-Str. 15', '07745 Jena', 'Germany'],
    phone: '+49 3641 519 5330',
    fax: '+49 3641 519 5331',
    email: 'info@biolitecpharma.com',
  },
  {
    name: 'biolitec Pharma Ltd. — Dublin',
    lines: ['Unit 9A — Plato Business Park, Damastown', 'Dublin 15', 'Ireland'],
  },
];

export default function Contact() {
  return (
    <>
      <PageHero
        eyebrow="CONTACT"
        title="Get in touch"
        subtitle="For questions about our company, Foscan® or photodynamic therapy."
      />

      <div className="page-shell">
        <FadeUp>
          <section className="page-section" id="offices">
            <h2 className="page-section-title">Our offices</h2>
            <div className="office-grid">
              {offices.map((o) => (
                <div key={o.name} className="office-card">
                  <span className="office-icon" aria-hidden="true"><IconPin /></span>
                  <h3 className="office-name">{o.name}</h3>
                  <p className="office-address">
                    {o.lines.map((l) => (
                      <span key={l}>{l}<br /></span>
                    ))}
                  </p>
                  {o.phone && (
                    <dl className="office-rows">
                      <div className="office-row">
                        <dt>Phone</dt>
                        <dd><a href={`tel:${o.phone.replace(/[^\d+]/g, '')}`}>{o.phone}</a></dd>
                      </div>
                      {o.fax && (
                        <div className="office-row">
                          <dt>Fax</dt>
                          <dd>{o.fax}</dd>
                        </div>
                      )}
                      <div className="office-row">
                        <dt>Email</dt>
                        <dd><a href={`mailto:${o.email}`}>{o.email}</a></dd>
                      </div>
                    </dl>
                  )}
                </div>
              ))}
            </div>
          </section>
        </FadeUp>

        <section className="page-section" id="medical-information">
          <h2 className="page-section-title">Medical information</h2>
          <p className="page-body">
            For product and clinical enquiries from healthcare professionals, please
            contact our medical information team directly.
          </p>
          <MedicalInfoCard
            org="biolitec Pharma Ltd. — Jena Office"
            address={['Otto-Schott-Str. 15', '07745 Jena', 'Germany']}
            phone="+49 3641 519 5330"
            fax="+49 3641 519 5331"
            email="medinfo@biolitecpharma.com"
            docLabel="View product information"
            docHref={EMA_URL}
          />
        </section>

        <FadeUp>
          <section className="page-section" id="online">
            <div className="inline-note">
              <span className="office-icon" aria-hidden="true"><IconGlobe /></span>
              <p>
                Internet:{' '}
                <a href="https://www.biolitecpharma.com" target="_blank" rel="noopener noreferrer">
                  www.biolitecpharma.com
                </a>
              </p>
            </div>
          </section>
        </FadeUp>
      </div>
    </>
  );
}